import { createPortal } from "react-dom";
import { createRootRouteWithContext, HeadContent, Outlet } from "@tanstack/react-router";

import { Toasts } from "@/components";
import type { RootContext } from "@/config/router";

const RootComponent = () => {
  return (
    <>
      {/* Renders the `head` of the matched routes. Without it every route `head` is dead
          code; a route that sets none keeps the static `<title>` from `index.html`. */}
      <HeadContent />

      <a
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-50 focus:rounded-full focus:bg-surface-inverted focus:px-5 focus:py-3 focus:font-semibold focus:text-content-on-inverted"
        href="#main-content"
      >
        Skip to main content
      </a>

      <Outlet />

      {createPortal(<Toasts />, document.body)}
    </>
  );
};

export const Route = createRootRouteWithContext<RootContext>()({ component: RootComponent });
